import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { getAuthorBySlugWithBlogPagePosts } from '../../../api/services/blogPostAuthorsApi';

import BlogLayout from '../../../components/main/blog/BlogLayout/BlogLayout';
import LinkifiedText from '../../../components/shared/LinkifiedText/LinkifiedText';
import BlogPostExcerptsList from '../../../components/main/blog/BlogPostExcerptsList/BlogPostExcerptsList';
import BlogSideBar from '../../../components/main/blog/BlogSideBar/BlogSideBar';

import { FaUser } from 'react-icons/fa';

import './BlogAuthor.css';

const BlogAuthor = () => {
  const { slug } = useParams();

  const [author, setAuthor] = useState(null);
  const [blogPosts, setBlogPosts] = useState([]);
  const [isLoadingAuthor, setIsLoadingAuthor] = useState(true);

  /* ---------- Fetch ---------- */

  const getAuthorWithBlogPosts = useCallback(async () => {
    setIsLoadingAuthor(true);

    try {
      const authorWithBlogPosts = await getAuthorBySlugWithBlogPagePosts(slug);

      setAuthor(authorWithBlogPosts.author);
      setBlogPosts(authorWithBlogPosts.posts);
    } catch (err) {
      console.error('Failed to fetch author:', err);
      setAuthor(null);
      setBlogPosts([]);
    } finally {
      setIsLoadingAuthor(false);
    }
  }, [slug]);

  useEffect(() => {
    getAuthorWithBlogPosts();
  }, [getAuthorWithBlogPosts]);

  /* ---------- Loading ---------- */

  if (isLoadingAuthor) return <p>Loading...</p>;

  if (!author) return <p>Author not found.</p>;

  /* ---------- Render ---------- */

  return (
    <div className='blog-author-page-container'>
      <div className='blog-author-title-container'>
        <h1 className='blog-author-title'>BLOG</h1>
      </div>

      <BlogLayout sidebar={<BlogSideBar />}>
        {/* Author Info */}
        <div className='blog-author-metadata-container'>
          <h2>About: {author.name}</h2>

          <div className='blog-author-img-and-bio-container'>
            <div className='blog-author-avatar-container'>
              {author.avatarUrl ? (
                <img
                  src={author.avatarUrl}
                  alt={`${author.name} avatar`}
                  className='blog-author-avatar'
                />
              ) : (
                <FaUser className='blog-author-author-icon' />
              )}
            </div>

            <div className='blog-author-bio-container'>
              <LinkifiedText>{author.bio}</LinkifiedText>
            </div>
          </div>
        </div>

        {/* Posts */}
        <h2>Recent Posts by {author.name}</h2>

        <BlogPostExcerptsList
          blogPosts={blogPosts}
          isLoading={isLoadingAuthor}
        />
      </BlogLayout>
    </div>
  );
};

export default BlogAuthor;
